<template>
    <v-card @click="toggleWalletDialogDidi" class="d-flex flex-nowrap price-wallet align-self-center font-size-h4" flat
            dark
            :max-width="$vuetify.breakpoint.mdAndUp ? '' : 400" :min-width="$vuetify.breakpoint.mdAndUp ? 232 : 85"
            height="32">
        <div class="d-flex align-center fill-height" style="flex: 1 0 auto" v-b-tooltip="'افزایش موجودی'">
            <span>افزایش موجودی</span>

            <v-spacer/>

            <span style="max-width: calc(90% - 40px);overflow: hidden;text-overflow: ellipsis;white-space: nowrap;direction: ltr">
        </span>

            <v-spacer/>

            <v-icon dark v-if="wallet.icon != null && wallet.icon.length > 0" v-text="wallet.icon"/>
        </div>

        <v-btn color="#6cdb72" class="price-walletButton px-0" style="margin-right: 12px" min-width="32" min-height="32"
               height="32" dark depressed @click.stop="toggleWalletDialogDidi" v-b-tooltip.passive="'شارژ کیف پول'">
            <v-icon class="plus" small>
                mdi-plus
            </v-icon>
        </v-btn>

        <wallet v-model="didi"/>
    </v-card>
</template>

<script>
import Wallet from "./wallet";
import {mapActions, mapGetters} from 'vuex'

const exhale = ms =>
    new Promise(resolve => setTimeout(resolve, ms))

export default {
    name: "WalletOpenButton",
    components: {Wallet},
    props: {
        hideInMobile: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        didi: false,
        checking: false,
        heartbeats: []
    }),
    mounted() {
        let classes = window.document.querySelectorAll(".price-wallet .v-input__control .v-text-field__slot *");
        for (let c of classes) {
            c.classList.add('on-scroll-shoed');
        }
    },
    created() {
        this.takePulse(false)
    },
    methods: {
        toggleWalletDialogDidi() {
            this.didi = !this.didi
        },
        changeRoute() {
            let a = document.createElement('a');
            a.target = '_blank';
            a.href = `${this.front_url}/#/user/transactions`;
            a.click()
            document.removeChild(a);
        },
        heartbeat() {
            return Math.ceil(Math.random() * (120 - 80) + 80)
        },
        async takePulse(inhale = true) {
            this.checking = true

            inhale && await exhale(1000)

            this.heartbeats = Array.from({length: 20}, this.heartbeat)

            this.checking = false
        },
    },
}
</script>

<style scoped>
.header-fixed .price-wallet,
.header-fixed .price-wallet i {
    color: #001554;
}

.price-wallet {
    padding-right: 12px;
    align-items: center;
    border-radius: 6px !important;
    background-color: rgba(255, 255, 255, .2);
    flex: 1 0 0;
}

.price-walletButton {
    border-radius: 6px 0 0 6px !important;
}
</style>
